export default function(selector) {
  return function() {
    return this.matches(selector);
  };
}

export function childMatcher(selector) {
  return function(node) {
    return node.matches(selector);
  };
}




// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-selection/src/matcher.js